export const Header = ( { onClick } ) => (
  <nav className="navbar navbar-expand-xxl">
    <div className="container-fluid">
      <h5>
        <a className="navbar-brand" href="#" onClick={() => onClick('default')} style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" width="40" height="40" />
          {" "}Fatty Acylizer
        </a>
      </h5>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link active" aria-current="page" href="#" onClick={() => onClick('publication')}>
              Publication
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#" onClick={() => onClick('documentation')}>
              Documentation
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#" onClick={() => onClick('tutorial')}>
              Tutorial
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="http://biochemgen.at" target="_blank">
              Contact
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="https://github.com/Biochemical-Genetics/Fatty-Acylizer" target="_blank">
              GitHub
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
)
